import {
  IncentiveCategory,
  IncentiveProgram,
} from '@varo/graphql-schema-types';
import {
  parseSweepstakesContentV1,
  SweepstakesContentV1,
} from 'features/incentive/content/sweepstakesContentV1';
import { logBreadcrumb } from 'shared/utils/sentry/sentry';

export type IncentiveContent = {
  incentiveType: IncentiveCategory.Sweepstakes;
  schemaVersion: 'v1';
  content: SweepstakesContentV1;
};

type IncentiveContentParser = (value: unknown) => IncentiveContent | undefined;

const INCENTIVE_CONTENT_PARSERS: Record<
  IncentiveCategory,
  Record<string, IncentiveContentParser>
> = {
  [IncentiveCategory.Sweepstakes]: {
    v1: (value) => {
      const content = parseSweepstakesContentV1(value);

      return content
        ? {
            incentiveType: IncentiveCategory.Sweepstakes,
            schemaVersion: 'v1',
            content,
          }
        : undefined;
    },
  },
};

const readProgramContent = (programContent: unknown): unknown => {
  if (typeof programContent !== 'string') {
    return programContent;
  }

  try {
    const parsedContent: unknown = JSON.parse(programContent);
    return parsedContent;
  } catch (error) {
    logBreadcrumb({
      level: 'error',
      message: 'Incentive programContent is not valid JSON',
      data: { error },
    });
    return undefined;
  }
};

export const resolveIncentiveContent = (
  program: Pick<
    IncentiveProgram,
    'incentiveType' | 'programContentSchemaVersion' | 'programContent'
  >,
): IncentiveContent | undefined => {
  const parseContent =
    INCENTIVE_CONTENT_PARSERS[program.incentiveType]?.[
      program.programContentSchemaVersion
    ];

  return parseContent?.(readProgramContent(program.programContent));
};
